/**
 * Routes that require authentication.
 * Used by the client-side UserContextProvider to redirect to `/` after sign-out.
 * NOT enforced server-side — account pages rely on API-level authorization
 * and client routing for access control.
 */
export const PROTECTED_ROUTE_PREFIXES = ['/account'] as const;

export function isProtectedRoute(pathname: string): boolean {
  return PROTECTED_ROUTE_PREFIXES.some(
    prefix => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}
